export const IGNORED_LINKS = ['profile'];
export const COMMON_LINKS = ['profile', '1_exit'];
